import { ReactNode, useContext, useEffect } from 'react';

import { TopMenuContext } from './Context';

export const useSetExtraSection = (item: ReactNode) => {
  const context = useContext(TopMenuContext);

  useEffect(() => {
    context?.setExtraSection(item);
    return () => context?.setExtraSection(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
